import React from "react";
import "./LeadDetailSidebar.scss"; // Eigene Styling-Datei
import ProductDetailCard from "features/leadProviders/waitingListLeadV1/components/ProductDetailCard";
import { useNavigate } from "react-router-dom";

interface LeadDetailSidebarProps {
    selectedLead: {
        id: string;
        leadNumber: string;
        product: number;
        location: string;
        soldDate: string;
        fullName: string;
        origin: number;
        link: string;
        status: number;
    };
    onClose: () => void;
}

const LeadDetailSidebar: React.FC<LeadDetailSidebarProps> = ({ selectedLead, onClose }) => {
    const navigate = useNavigate();
    return (
        <div className="detail-sidebar-right">
            <div className="task-details">
                <div className="sidebar-header">
                    <h2>Klientendetails</h2>
                    <div className="header-actions">
                        <button className="details-button"
                        onClick={() => navigate(`/waiting-list-lead-details`)}>Details</button>
                        <button className="details-button" onClick={onClose}>
                            <i className="fa-solid fa-close close-icon "  />
                        </button>
                    </div>
                </div>

                <ProductDetailCard
                    type="text"
                    title="Name"
                    content={selectedLead.fullName || "-"}
                />
                <ProductDetailCard
                    type="text"
                    title="Anfragen-Nummer"
                    content={selectedLead.leadNumber || "-"}
                />
                <ProductDetailCard
                    type="text"
                    title="Anfrage-Datum"
                    content={new Date(selectedLead.soldDate).toLocaleString("de-DE") || "-"}
                />
                <ProductDetailCard
                    type="text"
                    title="Bedarfsort"
                    content={selectedLead.location || "-"}
                />
                <ProductDetailCard
                    type="dropdown"
                    title="Status"
                    content={String(selectedLead.status) || "-"}
                    options={[
                        "Neue Anfrage",
                        "Bedarf identifiziert",
                        "Klient gewonnen",
                        "Abgelehnt",
                        "In Bearbeitung",
                    ]}
                />
                <ProductDetailCard
                    type="dropdown"
                    title="Priorität"
                    content={String(selectedLead.status) || "-"}
                    options={[
                        "Hoch",
                        "Mittel",
                        "Niedrig",
                    ]}
                />
                <ProductDetailCard
                    type="dropdown"
                    title="Zuständiger Mitarbeiter"
                    content={String(selectedLead.status) || "-"}
                    options={[
                        "Peter Meier",
                        "Anna Müller",
                        "Max Mustermann",
                    ]}
                />
                <ProductDetailCard
                    type="textarea"
                    title="Beschreibung"
                    content={"Noch keine Beschreibung vorhanden"}
                />
                <ProductDetailCard
                    type="dropdown"
                    title="Produkt"
                    content={String(selectedLead.product) || "-"}
                    options={[
                        "Kurzzeitpflege",
                        "Vollstationäre Pflege",
                        "Pflegedienst",
                    ]}
                />
                <ProductDetailCard
                    type="editabletext"
                    title="Voraussichtliches Abschluss-Datum"
                    content={new Date(selectedLead.soldDate).toLocaleString("de-DE") || "-"}
                />
            </div>
        </div>
    );
};

export default LeadDetailSidebar;
